import { useState } from 'react';
import Header from "../../Common/header";
import Footer from "../../Common/footer";

import AccountTab from "./ProfileTabs/accountTab";
import ContributionsTab from "./ProfileTabs/contributionsTab";

import { HiOutlineUserCircle, HiOutlineDocumentText } from "react-icons/hi";
import useDocumentTitle from '../../Common/useDocumentTitle';

const secondaryNavigation = [
  { name: 'Account', href: '/profile', icon: HiOutlineUserCircle, componentName: AccountTab, current: true },
  { name: 'My Contributions', href: '/contributions', icon: HiOutlineDocumentText, componentName: ContributionsTab, current: false },
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

/**
 * Determines what the initial tab should be based on the "tab" url parameter.
 * 
 * @returns The integer index of the current tab.
 */
function getInitialTab() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  switch (urlParams.get("tab")) {
    case "Account":
      return 0;
    case "My Contributions":
      return 1;
    default:
      return 0;
  }
}

export default function UserProfile() {
  const [currentTab, setCurrentTab] = useState(getInitialTab);

  useDocumentTitle("Profile");

  /**
   * Displays current tab component.
   * 
   * @returns React Component.
   */
  function renderCurrentTab() {
    const Component = secondaryNavigation[currentTab].componentName;
    return <Component />;
  }


  return (
    <>
      <Header />

      <div className="bg-white dark:bg-gray-900">
        <div className="mx-auto max-w-6xl lg:flex lg:gap-x-8 lg:px-8">
          <aside className="flex overflow-x-auto border-b border-gray-900/5 py-4 lg:block lg:w-64 lg:flex-none lg:border-0 lg:py-20">
            <nav className="flex-none px-4 sm:px-6 lg:px-0">
              <ul role="list" className="flex gap-x-3 gap-y-1 whitespace-nowrap lg:flex-col">
                {secondaryNavigation.map((item, index) => (
                  <li key={item.name}>
                    <a
                      data-cy={item.name}
                      onClick={(e) => {
                        const url = new URL(window.location.href);
                        url.searchParams.set("tab", item.name);
                        window.history.replaceState(null, null, url);
                        setCurrentTab(index);
                      }}
                      className={classNames(
                        index === currentTab
                          ? 'bg-gray-50 text-blue-600 dark:bg-gray-800 dark:text-white'
                          : 'text-gray-700 hover:text-blue-600 hover:bg-gray-50 dark:text-gray-400 dark:hover:text-white dark:hover:bg-gray-800',
                        'group flex gap-x-3 rounded-md py-2 pl-2 pr-3 text-sm leading-6 font-semibold'
                      )}
                    >
                      <item.icon
                        className={classNames(
                          index === currentTab ? 'text-blue-600 dark:text-blue-500' : 'text-gray-400 group-hover:text-blue-600 dark:group-hover:text-blue-500',
                          'h-6 w-6 shrink-0'
                        )}
                        aria-hidden="true"
                      />
                      {item.name}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          </aside>

          <main className="px-4 py-16 sm:px-6 lg:flex-auto lg:px-0 lg:py-20">
            {renderCurrentTab()}
          </main>
        </div>
      </div>

      <Footer />
    </>
  )
}
